import axios from 'axios';

import { useMutation } from '@tanstack/react-query';
import { API_URL } from '@/lib/apiUrl';

const useLogout = () => {
  return useMutation({
    mutationFn: async () => {
      const { data } = await axios.post(
        API_URL + '/logout',
        {}, // Pass an empty body if required
        { withCredentials: true } // Ensure cookies are sent
      );
      return data;
    },
  });
};

export default useLogout;
